module.exports = __webpack_public_path__ + "media/images/michael-6780fdbc63b47525fda6c60bc8ee8adf.jpeg";